/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_FieldInputs */

const cs_builder_prop_field = /** @type {(inputs: Builder_Prop_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole`)
};

const en_builder_prop_field = /** @type {(inputs: Builder_Prop_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

/**
* | output |
* | --- |
* | "Field" |
*
* @param {Builder_Prop_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_field = /** @type {((inputs?: Builder_Prop_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_field(inputs)
	return cs_builder_prop_field(inputs)
});